module.exports = __webpack_public_path__ + "img/40_38_035_130.7b05c8bb.jpg";